import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  DatePicker,
  Spin,
} from "antd";
import { EditOutlined, HistoryOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";
import UploadFile from "@/components/UplaodFile";
const AttendanceModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const childRef = useRef();
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [currentItem, setCurrentItem] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [uploading, setUploading] = useState(false);
  useImperativeHandle(ref, () => ({
    openAdd: (item) => {
      setCurrentItem(item || null);
      setVisible(true);
      let punchTimeValue = null;
      let selected = null;
      if (item?.date && item.date.length >= 3) {
        const [y, m, d, h = 0, min = 0] = item.date;
        selected = dayjs(`${y}-${m}-${d}`, "YYYY-M-D");
        punchTimeValue = dayjs(`${y}-${m}-${d} ${h}:${min}`, "YYYY-M-D H:m");
      }

      setSelectedDate(selected);

      form.setFieldsValue({
        punchType: item?.type ? Number(item.type) : null,
        punchTime: punchTimeValue,
        remark: item?.remark || "",
      });
    },
    close: () => {
      setVisible(false);
      form.resetFields();
      setCurrentItem(null);
      setSelectedDate(null);
    },
  }));

  const addUpload = async (data) => {
     const invalidFiles = data.filter((item) => {
       const type = item.originFileObj?.type;
       if (!type) return false; 
       return type !== "image/jpeg" && type !== "image/png" && type !== "application/pdf";
     });
   
     if (invalidFiles.length > 0) {
       const fileNames = invalidFiles.map((item) => `"${item.name}"`).join(", ");
       message.error(`The following files are not valid: ${fileNames}`);
       childRef.current?.clearFileList();
       return;
     }
    setUploading(true);
    try {
      const uploadedFiles = await uploadFiles(data);
      setFiles((prev) => [...prev, ...uploadedFiles]);
    } catch (error) {
      message.error("File upload failed.");
    } finally {
      setUploading(false);
    }
  };

  async function uploadFiles(data) {
    const uploaded = [];
    for (const item of data) {
      const formData = new FormData();
      formData.append("files", item.originFileObj);

      const response = await http.post(api.getUpdateFileDict, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.code === "1") {
        uploaded.push(response.data[0]);
      } else {
        throw new Error(response.msg || "Upload failed");
      }
    }
    return uploaded;
  }

  const onFinish = async () => {
    if (uploading) {
      message.warning("Files are still uploading, please wait.");
      return;
    }
    setLoading(true);
    try {
      const values = await form.validateFields();

      const params = {
        ...values,
        fileSet: files,
        punchTime: values.punchTime.format("YYYY-MM-DD HH:mm:ss"),
      };
      console.log(values);
      const res = await http.post(api.getAddAttendance, params);

      if (res?.code === "1") {
        message.success("Attendance Created Successfully");
        setVisible(false);
        form.resetFields();
        setFiles([]);
        onSuccess?.();
      } else {
        message.error(res?.msg || "Operation failed");
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      width="60%"
      maskClosable={false}
      destroyOnClose
      title={
        <Flex align="center">
          <EditOutlined style={{ marginRight: 8 }} />
          <Typography.Title level={4} style={{ margin: 0 }}>
            Attendance Detail
          </Typography.Title>
        </Flex>
      }
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading || uploading}
          onClick={() => form.submit()}
        >
            Submit
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <div className="model_top" style={{ width: "100%" }}></div>
        <div className="model_content">
          <Form
            form={form}
            layout="horizontal"
            labelCol={{ style: { width: 200 } }}
            wrapperCol={{ style: { flex: 1 } }}
            onFinish={onFinish}
          >
            <Flex align="flex-start" justify="space-between" gap={32}>
              <div style={{ flex: 1 }}>
                <Form.Item label="Punch Type" name="punchType">
                  <Select
                    options={[
                      { value: 1, label: "AM Clock In" },
                      { value: 2, label: "AM Clock Out" },
                      { value: 3, label: "PM Clock In" },
                      { value: 4, label: "PM Clock Out" },
                    ]}
                    disabled={!!currentItem?.type}
                  />
                </Form.Item>

                {/* <Form.Item
                  label="Punch Time"
                  name="punchTime"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format="YYYY-MM-DD hh:mm A"
                    showTime={{
                      format: "hh:mm A",
                      use12Hours: true,
                    }}
                    disabledDate={(current) => {
                      if (!selectedDate) return true;
                      return !current.isSame(selectedDate, "day");
                    }}
                    disabledTime={(date) => {
                      if (!date) return {};

                      const now = dayjs();

                      //  只禁用非今天的未来时间
                      if (!date.isSame(now, "day")) {
                        return {};
                      }

                      const currentHour = now.hour(); // 0 - 23
                      const currentMinute = now.minute(); // 0 - 59

                      return {
                        // 禁用未来时分
                        disabledHours: () =>
                          Array.from({ length: 24 }, (_, h) => h).filter(
                            (h) => h > currentHour,
                          ),
                        disabledMinutes: (selectedHour) =>
                          selectedHour === currentHour
                            ? Array.from({ length: 60 }, (_, m) =>
                                m > currentMinute ? m : null,
                              ).filter(Boolean)
                            : [],
                      };
                    }}
                  />
                </Form.Item> */}

                <Form.Item label="Remark" name="remark">
                  <Input.TextArea maxLength={200} showCount />
                </Form.Item>
              </div>

              <div style={{ flex: 1 }}>
                {/* upload */}
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  Upload PDF image
                </div>
                <Form.Item
                  labelCol={{ span: 0 }}
                  wrapperCol={{ span: 24 }}
                  label={null}
                >
                  <div>
                    <div className="uploadText">
                      Uploaded files only support JPG, PNG or PDF.
                    </div>
                    <div
                      style={{ marginTop: "20px", display: "flex", gap: 16 }}
                    >
                      {/* Upload  */}
                      <div style={{ flex: 1 }}>
                        <div
                          style={{ fontWeight: "bold", marginBottom: "8px" }}
                        >
                          Upload
                        </div>
                        <Form.Item name="fileSet" noStyle>
                          <UploadFile
                            ref={childRef}
                            sendDataToParent={addUpload}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </Form.Item>
              </div>
            </Flex>
          </Form>
        </div>
      </Spin>
    </Modal>
  );
});

export default AttendanceModal;
